// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"numbers-circle-2"},"nodeName":"g","children":[{"attributes":{"id":"fill1","cx":12,"cy":12,"r":10,"fill":"transparent"},"nodeName":"circle","children":[]},{"attributes":{"id":"stroke1","cx":12,"cy":12,"r":10,"stroke":"currentColor","stroke-linecap":"square","stroke-width":2},"nodeName":"circle","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M15 17.5H9V16.0157C9 15.7949 9.10177 15.5858 9.27706 15.4466L13.8737 11.7948C14.5863 11.2287 15 10.3788 15 9.48109V9.43333C15 7.8133 13.6569 6.5 12 6.5C10.3431 6.5 9 7.8133 9 9.43333","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-numbers-circle-2')
export default class NumbersCircle2Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'numbers-circle-2',
    }
  }
}
